import { SHAPE_SVGS } from "./avvvatars-shapes";

// Avvvatars color palettes (from avvvatars-react/src/lib/colors.ts)
export const BACKGROUND_COLORS = [
  "F7F9FC", "EEEDFD", "FFEBEE", "FDEFE2", "E7F9F3",
  "EDEEFD", "ECFAFE", "F2FFD1", "FFF7E0", "FDF1F7",
  "EAEFE6", "E0E6EB", "E4E2F3", "E6DFEC", "E2F4E8",
  "E6EBEF", "EBE6EF", "E8DEF6", "D8E8F3", "ECE1FE",
];

export const SHAPE_COLORS = [
  "060A23", "5E36F5", "E11234", "E87917", "3EA884",
  "0618BC", "0FBBE6", "87B80A", "FFC933", "EE77AF",
  "69785E", "2D3A46", "280F6D", "37364F", "363548",
  "4D176E", "AB133E", "420790", "222A54", "192251",
];

export const TOTAL_SHAPES = 60; // Shape1 .. Shape60
export const TOTAL_COLORS = BACKGROUND_COLORS.length; // 20

/**
 * Renders an Avvvatars shape on a colored background.
 * shapeKey: 1-60, colorIndex: 0-19
 */
export const CustomAvatar = ({
  shapeKey,
  colorIndex,
  size,
}: {
  shapeKey: number;
  colorIndex: number;
  size: number;
}) => {
  const svgContent = SHAPE_SVGS[shapeKey];
  if (!svgContent) return null;

  const shapeSize = Math.round((size / 100) * 50);
  const bg = `#${BACKGROUND_COLORS[colorIndex] ?? BACKGROUND_COLORS[0]}`;
  const fg = `#${SHAPE_COLORS[colorIndex] ?? SHAPE_COLORS[0]}`;

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: size,
        backgroundColor: bg,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        viewBox="0 0 32 32"
        fill="none"
        width={shapeSize}
        height={shapeSize}
        style={{ color: fg }}
        dangerouslySetInnerHTML={{ __html: svgContent }}
      />
    </div>
  );
};

/** Format: "custom:<shapeKey>:<colorIndex>" e.g. "custom:5:3" */
export function parseCustomAvatar(
  seed: string | undefined | null,
): { shapeKey: number; colorIndex: number } | null {
  if (!seed?.startsWith("custom:")) return null;
  const parts = seed.split(":");
  if (parts.length !== 3) return null;
  const shapeKey = parseInt(parts[1], 10);
  const colorIndex = parseInt(parts[2], 10);
  if (isNaN(shapeKey) || isNaN(colorIndex)) return null;
  if (shapeKey < 1 || shapeKey > 60) return null;
  if (colorIndex < 0 || colorIndex > 19) return null;
  return { shapeKey, colorIndex };
}
